
import { Component, EventEmitter, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ButtonComponent } from '@mds/ui';
import { MatIconModule } from '@angular/material/icon';
import {
  ComplianceQuestionnaireCommentsComponent
} from '@pages/information-requests/request/compliance-questionnaire/compliance-questionnaire-comments/compliance-questionnaire-comments.component';

@Component({
  selector: 'app-compliance-questionnaire-bulk-status',
  templateUrl: './compliance-questionnaire-bulk-status.component.html',
  styleUrls: ['./compliance-questionnaire-bulk-status.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    ButtonComponent,
    MatIconModule,
    ComplianceQuestionnaireCommentsComponent,
  ],
})
export class ComplianceQuestionnaireBulkStatusComponent implements OnDestroy {
  submitDataEmitter = new EventEmitter();
  private destroy$ = new Subject<void>();
  comment = '';

  constructor(
    private dialogRef: MatDialogRef<ComplianceQuestionnaireBulkStatusComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onCancel() {
    this.dialogRef.close();
  }

  onStatusUpdate(status: string) {
    const payload = {
      status,
      comment: this.comment,
    };
    this.submitDataEmitter.emit(payload);
  }

  changeComment(comment: string) {
    this.comment = comment;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
